<p class="item">
  <mat-icon class="item__icon">info</mat-icon>
  <ng-content></ng-content>
</p>